// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationBankPath = 'M6 34.7a10.5 10.5 0 006 6.422V76H6.5v7h87v-7H88V41.122a10.5 10.5 0 006-6.422l2.8-7.9L50 3 3.2 26.8 6 34.7zM81 76V41.9H67V76h14zm-21 0V41.9H40V76h20zm-27 0V41.9H19V76h14zM11.8 30.2l.8 2.2a3.5 3.5 0 003.3 2.5h17.228C34.163 26.502 41.322 20 50 20c8.678 0 15.837 6.502 16.871 14.9H84.1a3.5 3.5 0 003.3-2.5l.8-2.2L50 10.8 11.8 30.2zM50 27c4.803 0 8.814 3.385 9.78 7.9H40.22c.966-4.515 4.977-7.9 9.78-7.9zm47 62H3v7h94v-7z';
var IllustrationBank = baseIllustration('IllustrationBank', {
  getPath: () => IllustrationBankPath
}, 'ColoredIllustrationBank');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationBank;
//# sourceMappingURL=index.js.map